module.exports = __webpack_public_path__ + "static/media/birth-control-condom-contraception-svgrepo-com.c1ae045a.svg";